.tab {
  border-radius: 9999px;
  flex-shrink: 0;
}

.image {
  border-radius: 16px;
  width: 116px;
  height: 92px;

  @media (--reefer-media-tablet-min) {
    width: 141px;
    height: 100px;
  }

  > div {
    flex: 1;
    max-height: 40px;
    max-width: 40px;
    aspect-ratio: 1;
    min-height: 0;

    @media (--reefer-media-tablet-min) {
      max-height: 48px;
      max-width: 48px;
    }
  }
}

.image_icon {
  width: 100%;
  height: 100%;
  max-width: 32px;
  max-height: 32px;
}

.image_selected {
  border-width: 2px;
}
